import React from 'react';
import { Img, Text, Button, Icon } from '../../Atoms';
import { Input, Modal } from '../../Molecules';
import notifTel from '../../assets/img/notifTel.png';
import { COLOR_BUTTON } from '../../Config/Config';

function ModalCertificate(props) {
  return (
    <Modal
      show={props.show}
      showIconClose={false}
      centered={true}
      contentClassName={'content-modal-confirm-password'}
    >
      <div className="full-container">
        <Icon
          icon="BigX"
          className="icon-close-modal-confim-password"
          size="20px"
          onClick={() => props.onClose()}
        />
        <Text
          text={`Prolongation des droits de votre enfant `}
          className="title-modal-confirm-password"
        />
        <p
          style={{ fontFamily: 'Mont', marginBottom: 10, textAlign: 'center' }}
        >
          La couverture santé de votre(vos) enfant(s) arrive à échéance.
        </p>

        <p
          style={{ fontFamily: 'Mont', marginBottom: 10, textAlign: 'center' }}
        >
          Afin d'étudier la prolongation des droits, des justificatifs sont
          nécessaires.
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
          <Button
            type="primary"
            text="Prolonger les droits"
            className="btn-submit-modal-edit-profile"
            color={COLOR_BUTTON.SECOND_RED}
            onClick={() => props.submit()}
          />
        </div>
      </div>
    </Modal>
  );
}

export default ModalCertificate;
